const initialState = {
    isOpen: false,
    currentVersion: null,
    latestVersion: null,
    deviceName: null,
    firmwareCheck: null,
}

const firmwareUpdateDialogReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SHOW_FIRMWARE_UPDATE_DIALOG':
            return {
                ...state,
                isOpen: true,
                currentVersion: action.payload.currentVersion,
                latestVersion: action.payload.latestVersion,
                deviceName: action.payload.deviceName,
                firmwareCheck: action.payload.firmwareCheck,
            }

        case 'HIDE_FIRMWARE_UPDATE_DIALOG':
            return {
                ...state,
                isOpen: false,
                currentVersion: null,
                latestVersion: null,
                deviceName: null,
                firmwareCheck: null,
            }

        default:
            return state
    }
}

export default firmwareUpdateDialogReducer
